import React,{Component} from 'react';
import i18n from '../../i18n';
import {Toast} from '@react/react-spectrum/Toast';
class Disclaimer extends Component{	
	render(){
        return(
            <div className="discalimer-outer">
            	<Toast variant="info" className="disclaimer">
                    {i18n.t(this.props.workFlowId+'.approvalHeaderInfo.disclaimerHeader')} &nbsp;
                    {(this.props.workFlowId === 'ADD_LICENSE') ? (<span>{i18n.t(this.props.workFlowId+'.approvalHeaderInfo.disclaimerMessage')}</span>) : (<span>{i18n.t(this.props.workFlowId+'.approvalHeaderInfo.disclaimerMessage')}</span>)}
                </Toast>
            </div>
        )
    }
}

export default Disclaimer;